import { ClassNameProps, makeClassName, Row, StyleProps } from "@hex-insights/core";
import { Icon } from "@hex-insights/verita-romania.shared";
import styles from "./styles.module.css";

export type ContractLockedNoticeProps = Partial<ClassNameProps & StyleProps>;

export function ContractLockedNotice({ className, style }: ContractLockedNoticeProps) {
	return (
		<Row justify="spaced-start" align="center" className={makeClassName(styles["notice"], className)} style={style}>
			<Icon.Lock size={24} color="var(--primary-color)" />

			<span>
				This contract has been approved and cannot be changed at this time. If you need to make a change please contact
				an administrator.
			</span>
		</Row>
	);
}
